import { useEffect, useId, useRef } from 'react';

/** Canonical legal pages on bildit.co (same as bildit-web-nextjs). */
export const BILDIT_PRIVACY_POLICY_URL = 'https://bildit.co/privacy-policy/';
export const BILDIT_TERMS_CONDITIONS_URL = 'https://bildit.co/terms-conditions/';

const DOC_CONFIG = {
  terms: {
    title: 'Terms of Service',
    url: BILDIT_TERMS_CONDITIONS_URL,
  },
  privacy: {
    title: 'Privacy Policy',
    url: BILDIT_PRIVACY_POLICY_URL,
  },
};

/**
 * In-app popup that loads the live BILDIT marketing legal pages.
 * @param {{ doc: 'terms' | 'privacy' | null, onClose: () => void }} props
 */
function LegalDocModal({ doc, onClose }) {
  const titleId = useId();
  const closeRef = useRef(null);
  const config = doc ? DOC_CONFIG[doc] : null;

  useEffect(() => {
    if (!config) {
      return undefined;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();

    const onKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [config, onClose]);

  if (!config) {
    return null;
  }

  return (
    <div className="onboarding-legal-modal" role="presentation">
      <button
        type="button"
        className="onboarding-legal-modal__backdrop"
        aria-label="Close dialog"
        onClick={onClose}
      />
      <div
        className="onboarding-legal-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <header className="onboarding-legal-modal__header">
          <h2 id={titleId} className="onboarding-legal-modal__title">
            {config.title}
          </h2>
          <button
            ref={closeRef}
            type="button"
            className="onboarding-legal-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </header>
        <iframe
          className="onboarding-legal-modal__frame"
          src={config.url}
          title={config.title}
        />
        <footer className="onboarding-legal-modal__footer">
          <a
            href={config.url}
            target="_blank"
            rel="noopener noreferrer"
            className="onboarding-legal-modal__external"
          >
            Open full page
          </a>
        </footer>
      </div>
    </div>
  );
}

export default LegalDocModal;
